/*
 * domAnimation offers support for animations, variants, exit animations, and tap/hover/focus gestures.
 * We export it here in order to load it async.
 */

import {domAnimation} from 'motion/react'
export default domAnimation
